import { Epic, StateObservable } from 'redux-observable'
import { from, of } from 'rxjs'
import { catchError, filter, map, mergeMap } from 'rxjs/operators'
import { isActionOf } from 'typesafe-actions'

import { getThemeCities } from '../../../data/api/themeCities'
import { AppState } from '../../../data/state'

import * as actions from './actions'

export const funnelOrderThemeCitiesEpic: Epic = (
  action$,
  state$: StateObservable<AppState>,
) =>
  action$.pipe(
    filter(isActionOf(actions.funnelOrderThemeCitiesGetRequest)),
    mergeMap(() =>
      from(
        getThemeCities(
          state$.value.funnelOrder.theme,
          state$.value.locale.country,
        ),
      ).pipe(
        map(actions.funnelOrderThemeCitiesGetResponse),
        catchError((error: Error) =>
          of(actions.funnelOrderThemeCitiesGetFailure(error)),
        ),
      ),
    ),
  )
